import React from "react";
import TabPanel from "../../../containers/rechargeSales/sales/component/tabPanel";
import { getSalesHeader } from "../../../utils/common/index";
import RechargeSalesInsights from "../../../containers/rechargeSales/insights/rechargeSalesInsights";
import MobileSalesTilePicker from "../../../components/MobileSalesTilePicker";

function SalesView(props) {
  let {
    sideHandleChangeDesktop,
    setSideValue,
    sideValue,
    ts,
    RenderPanel,
    filterValue,
    insightsSection,
  } = props;

  const activeTiles = (props.data || []).filter(
    (tile) => tile.isTileActive === "Y"
  );

  return (
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
    >
      <div className="subtitlebox">
        <div className="subtitleboxChild">Recharge Sales Dashboard</div>
        {/* <div>{ts}</div> */}
      </div>
      {insightsSection && filterValue && (
        <div className="insights-section-wrapper mt-3">
          <RechargeSalesInsights
            section={insightsSection}
            filterValue={filterValue}
          />
        </div>
      )}
      <div className="tabcontbox">
        <div className="row align-items-start recharge-sales-tab-row">
          <div className="col-12 col-md-4 d-block d-sm-none recharge-sales-tile-select-wrap">
            <div className="recharge-sales-types-heading mb-2">TYPES OF SALES</div>
            {setSideValue ? (
              <MobileSalesTilePicker
                activeTiles={activeTiles}
                sideValue={Number(sideValue)}
                onSelectIndex={setSideValue}
              />
            ) : null}
          </div>
          <div className="d-none d-sm-block col-md-3 align-self-start">
            <div className="recharge-sales-types-heading">TYPES OF SALES</div>
            <div className="rsdlist mt-2">
              <ul>
                {props.data
                  .filter((tile) => tile.isTileActive === "Y")
                  .map((tile, index) => {
                    const header = getSalesHeader(tile.tileName);

                    return (
                      <li key={index}>
                        <a
                          href={`#rsd${index + 1}`}
                          onClick={() => {
                            sideHandleChangeDesktop(tile, index);
                          }}
                          className={sideValue === index ? "active" : ""}
                        >
                          {tile.tileName + header}
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-9">
            {props.data
              .filter((tile) => tile.isTileActive === "Y")
              .map((tile, index) => (
                <TabPanel key={index} value={sideValue} index={index}>
                  <RenderPanel
                    tileName={tile.tileName}
                    url={tile.tileEndPointUrl}
                    csvUrl={tile.csvEndPointUrl}
                    isCsvActive={tile.isCsvActive}
                    filterValue={props.filterValue}
                    data={props.data}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    moduleName={props.moduleName}
                    id={index + 1}
                    section={props.section}
                  />
                </TabPanel>
              ))}
          </div>
        </div>
      </div>
      <div className="card-timestamp border-top mt-2">
        <i className="fa fa-history mr-2 mt-2 mb-0"></i>
        Updated on {ts}
      </div>
    </div>
  );
}

export default SalesView;
